module.exports = __webpack_public_path__ + "img/reservatorio.d48f4883.png";